import ApiService from "./api.service";

const ACCOUNT_ID_KEY = 'st_account_id';
const ORG_ID_KEY = 'st_pcuel_organization_id';

export const getPcuelAccountId = () => window.localStorage.getItem(ACCOUNT_ID_KEY);

export const savePcuelAccountId = (id) => {
    window.localStorage.setItem(ACCOUNT_ID_KEY, id);
};

export const destroyPcuelAccountId = () => {
    window.localStorage.removeItem(ACCOUNT_ID_KEY);
};

export const getPcuelOrganizationId = () => window.localStorage.getItem(ORG_ID_KEY);

export const savePcuelOrganizationId = (id) => {
    window.localStorage.setItem(ORG_ID_KEY, id);
};

export const destroyPcuelOrganizationId = () => {
    window.localStorage.removeItem(ORG_ID_KEY);
};

export const fetchLastPcuelSync = async (accountId) => {
    if (!accountId) return null;
    try {
        const { data } = await ApiService.query('/building-permit/last-sync', {
            params: { accountId },
        });
        return data;
    } catch (error) {
        console.error('[PCUEL last sync] fetch failed', error?.response?.status || error?.message);
        return null;
    }
}

export default {
    getPcuelAccountId,
    savePcuelAccountId,
    destroyPcuelAccountId,
    getPcuelOrganizationId,
    savePcuelOrganizationId,
    destroyPcuelOrganizationId,
    fetchLastPcuelSync
};
